/**
 * Format to Brazilian currency
 */

import { InputState } from 'react-input-mask';

/**
 * Formats any string into Brazilian currency from its digits, cash-register
 * style: '123456' -> 'R$ 1.234,56'. Empty (no digits) stays empty.
 */
export const formatCurrencyString = (value: string): string => {
  const digits = value.replace(/\D/g, '').replace(/^0+/g, '');

  if (!digits) return '';
  if (digits.length === 1) return `R$ 0,0${digits}`;
  if (digits.length === 2) return `R$ 0,${digits}`;

  const withComma = digits.replace(/(?=\d{2})(\d{2})$/, ',$1');
  const withDots = withComma.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  return `R$ ${withDots}`;
};

export default function maskToCurrency(
  newState: InputState,
  oldState: InputState,
  userInput: string,
  maskOptions: any,
  currency: 'Brazilian' | 'American' = 'Brazilian'
) {
  const { value } = newState || {};

  if (currency === 'Brazilian') {
    const amountFormatted = value?.replace?.(/\D/g, '')?.replace?.(/^0+/g, '');
    if (amountFormatted?.length === 1) {
      return {
        ...newState,
        value: `R$ 0,0${amountFormatted}`,
        selection: {
          start: amountFormatted.length + 6,
          end: amountFormatted.length + 6,
        },
      };
    }

    if (amountFormatted?.length === 2) {
      return {
        ...newState,
        value: `R$ 0,${amountFormatted}`,
        selection: {
          start: amountFormatted.length + 5,
          end: amountFormatted.length + 5,
        },
      };
    }

    const amountFormattedWithComma = amountFormatted?.replace?.(
      /(?=\d{2})(\d{2})$/,
      ',$1'
    );
    const amountFormattedWithDot = amountFormattedWithComma?.replace?.(
      /(\d)(?=(\d{3})+(?!\d))/g,
      '$1.'
    );

    if (amountFormattedWithDot) {
      return {
        ...newState,
        value: `R$ ${amountFormattedWithDot}`,
        selection: {
          start: amountFormattedWithDot.length + 3,
          end: amountFormattedWithDot.length + 3,
        },
      };
    }
  }

  if (currency === 'American') {
    return {
      ...newState,
      value: Number(value).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      }),
    };
  }

  return newState;
}
